import { useMeta } from 'vue-meta'
import { RouteLocationNormalizedLoaded } from 'vue-router'

export default function setMeta (route: RouteLocationNormalizedLoaded) {
  if (process.env.NODE_ENV === 'production') {
    useMeta(route.meta)
  }
}
